<template>
    <div id='about' class='container'>
		<div>
			<h6 class='heading'>{{$t('h-about')}}</h6>
			<object type="image/svg+xml" data="img/about.svg" alt='svglogo'>Your browser does not support SVGs</object>
			
		</div>

		<div >
			<strong class='letter'>{{$t('about-content-1')}}</strong>
			<p>{{$t('about-content-2')}}</p>
		</div>

		<div>	
			<strong class='letter'>{{$t('about-content-3')}}</strong>
			<p>{{$t('about-content-4')}} </p><br>
			<a href="https://www.fb.com/timvma" class="link2 center">{{$t('about-content-5')}}</a>
		</div>


		<div class="img-hover1">
			<img src="img/moon480.webp" alt="moon" width='1080px' height="1350px">
		</div>
	
	</div>
</template>

<script>


export default {
    name:"page-about"
}
</script>
